/** App\Enums\FeedbackCategory */
export enum FeedbackCategory {
  Spacing = 'spacing',
  Typography = 'typography',
  Color = 'color',
  Layout = 'layout',
  Component = 'component',
  Content = 'content',
  Functionality = 'functionality',
  Accessibility = 'accessibility',
  Performance = 'performance',
  Responsiveness = 'responsiveness',
  Ux = 'ux',
  Seo = 'seo',
  /** Set by the link checker only. */
  BrokenLinks = 'broken_links',
  /** Set by the spelling & grammar check only. */
  SpellingGrammar = 'spelling_grammar',
  Other = 'other',
}
